import TeamPhotoSelector from './TeamPhotoSelector';

export default TeamPhotoSelector;
